<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" class="button" @click="$router.go(-1)">返回</button>
			</p>
			<p>
				<hr style="margin: .5rem;" />
				{{booksName}}
				<button type="button" class="button add" @click="Edit='up'">+新增</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>图片</th>
						<th>图片类型</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in images">
						<td>
							{{index+1}}
						</td>
						<td>
							<img :src="$store.state.imageUrl +'/' +i.ImageName" />
						</td>
						<td>
							<div style="margin: 0 auto;text-align: left;width: 8rem;">
								{{'图片状态:'+(i.ImageState==0? '正常':'停用')}}
								<br />
								{{'图片类型:'+(i.ImageType==0? '封面':'内容')}}
								<br />
								{{'图片上传:'+i.UserName}}
								<br />
								{{'上传时间:'+i.OperationTime.substring(0,10)}}
							</div>

						</td>
						<td>
							<button type="button" class="button"
								@click='setBookImageSate(i.BooksImageID,  i.ImageState==0?1:0)'>
								{{i.ImageState==0? '停用':'恢复'}}
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="edit" v-show="Edit!=''">
			<div>
				<p>
					<label>
						<span class="red"></span>图片类型:
						<select v-model="ImageType" title="请选择用户类型">
							<option value="0">封面</option>
							<option value="1">内容</option>
						</select>
					</label>
				</p>
				<p>
					<label>
						选择文件:
						<button type="button" class="button" @click="selectFile">点击选择图片</button>
						<input type="file" style="display:none;" ref='camear' />
						<span class="err">{{checkFile}}</span>
					</label>
				</p>
				<p style="text-align: center;">
					<img :src="img" ref='preview' style="width: 10rem;height: auto;" />

				</p>

				<p>
					<button class="button" :class="{'disabled':checkFile.length>0}" :disabled="checkFile.length>0"
						@click="editUsers">上传</button>
					<button class="button" @click="Edit=''">取消</button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: 'bookMangmentImage',
		data() {
			return {
				Edit: '',
				images: [],
				BooksID: 0,
				ImageType: 0,
				fileName: '',
				file: '',
				getData: {},
				img: '',
				booksName: ''

			};
		},
		created() {
			this.getData = function() {
				this.BooksID = this.$route.params.booksID;
				this.$request.request({
					url: 'books/getBooksImage',
					data: {
						BooksID: this.BooksID
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.images = res.BooksImage;
						this.booksName = "书籍名称:" + res.BooksName;
					}
				});
			}

			this.getData();
		},
		methods: {
			selectFile(e) {
				let camear = this.$refs.camear;
				camear.click();
				let img = this.$refs.camear;
				let that = this;
				camear.onchange = function() {

					that.file = this.files[0];
					that.fileName = this.files[0].name;
					//if(this.checkFile.length>0) return;
					var reader = new FileReader();
					//reader.readAsText(文件对象); 读取文件里面的内容

					reader.readAsDataURL(this.files[0]);
					reader.onload = function() {
						that.img = this.result;
					};
				};
				//this.fileName=this.file.name;
			},
			setBookImageSate(id, state) {
				this.$request.request({
					url: 'books/setBoooksImage',
					data: {
						state: state,
						BooksImageID: id
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.getData();

					}
				});
			},
			editUsers() {
				this.Edit = '';

				let param = new FormData()
				param.append('BooksID', this.BooksID);
				param.append('ImageType', this.ImageType);
				param.append('OperatorID', this.$store.state.user.UserID);
				param.append('file', this.file);
				this.$request.upLoadFile({
					url: 'books/UploadImage',
					data: param,
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.$uil.showMessage({
							text: res.message
						});
						this.getData();
					}
				});
			}

		},
		computed: {
			checkFile() {
				if (this.fileName == '') return '请选择图片';
				let index = this.fileName.lastIndexOf('.');
				if (index == -1) return '格式错误';
				let ext = this.fileName.substring(index + 1);
				if (['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) == -1)
					return '格式错误';
				else
					return '';
			}
		},
		filters: {

		},
		watch: {
			$route(n, o) {
				if (n.path.indexOf('bookMangmentImage') == -1) return;
				let nbooksid = n.params.booksID;
				let obooksid = o.params.booksID;
				if (nbooksid != obooksid)
					this.getData();
			}

		}

	}
</script>

<style>
</style>
